__turbopack_context__.v({
  "className": "geist_mono_34594f47-module__jOBELG__className",
  "variable": "geist_mono_34594f47-module__jOBELG__variable",
});
